/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-16 11:17:41
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-28 09:35:03
 * @FilePath: /unifyxp-v2-store-portal/src/components/FieldModal/index.tsx
 */
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Icon } from '@/src/tools/icon';
import { get } from 'lodash';
import React from 'react';
import {
  // Input,
  Input,
  Modal,
  ModalFooter,
  OriCheckbox,
} from 'src/components/Antd';
import { Option, Select } from 'src/components/Antd/Select/OriginalSelect';
import { EnumFieldType as Name } from 'src/components/FieldModal/config';
import { useI18n } from 'src/hooks/useRouterChange';
import { instanceType } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { AllTypes } from 'src/types/common/common';
import css from './css.module.less';

//import { useAfterDidMountEffect } from 'src/tools/customHooks';
enum DOB {
  Year = 'Year',
  Month = 'Month',
  Date = 'Day',
}

export const disabledOption = {
  [Name.FullName]: [Name.FirstName, Name.LastName],
  [Name.FirstName]: [Name.FullName],
  [Name.LastName]: [Name.FullName],
};

const OTCTip = ({ tip }) => {
  return (
    <div className={css.otcContainer}>
      <Icon type='iconinfo2' className={css.icon} />
      {tip}
    </div>
  );
};

const FieldModal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //问一下没有好i 是不是能disable
  const {
    availableFields = [],
    field: _category,
    required: _required,
    visible,
    onOk,
    onCancel,
    index,
    dateOfBirthFields = [],
    isOptOptional,
    otpRequired: _otpRequired,
    title,
    placeholderRequired,
    placeholder: _placeholder,
    unChangeableFields,
  } = props;

  const unChangeable = unChangeableFields || [Name.Email];
  //console.log('props', props);
  const disableSelect = unChangeable.includes(get(props, 'field.fieldType'));

  const isAddNew = instanceType(index) !== AllTypes.Number;
  const [category, setCategory] = React.useState(
    _category || availableFields[0],
  );
  const hasValue = (category || {}).uuid;
  // console.log('category', category);
  const selectValue = {
    label: (category || {}).name,
    value: (category || {}).uuid,
  };

  const [required, setRequired] = React.useState(!!_required);
  const [otpRequired, setOptRequired] = React.useState(!!_otpRequired);
  const [placeholder, setPlaceholder] = React.useState(_placeholder);
  const [date, setDate] = React.useState({
    y: (dateOfBirthFields || []).includes(DOB.Year) ? true : false,
    m: (dateOfBirthFields || []).includes(DOB.Month) ? true : false,
    d: (dateOfBirthFields || []).includes(DOB.Date) ? true : false,
  });

  const [dateErr, setDateErr] = React.useState(false);

  const options = React.useMemo(() => {
    return availableFields.map((i) => {
      const { fieldType: cName } = category;
      const { uuid, fieldType, name, disabled } = i;
      if (disabled) {
        return (
          <Option value={uuid} key={uuid} disabled>
            {name}
          </Option>
        );
      } else {
        if ((disabledOption[cName] || []).includes(fieldType)) {
          return (
            <Option value={uuid} key={uuid}>
              {name}
            </Option>
          );
        } else {
          return (
            <Option value={uuid} key={uuid}>
              {name}
            </Option>
          );
        }
      }
    });
  }, [availableFields, category]);

  //   useAfterDidMountEffect(() => {
  //     setName((nameDict[category] || {}).defaultValue);
  //   }, [category]);

  const isDob = (category || {}).fieldType === Name.DateOfBirth;
  const isEmail = (category || {}).fieldType === Name.Email;
  const isMobile = (category || {}).fieldType === Name.AreaCodeMobileNumber;
  //const isDefault = (category || {}).defaultField;
  const otc = React.useMemo(() => {
    if (isMobile || isEmail) {
      if (isOptOptional) {
        return (
          <div className={css.otcCheckbox}>
            <OriCheckbox
              checked={otpRequired}
              onChange={(e) => {
                const checked = e.target.checked;
                setOptRequired(checked);
              }}>
              {getI18n('general.fieldModal.otp_required')}
            </OriCheckbox>
          </div>
        );
      } else {
        if (isMobile) {
          return <OTCTip tip={getI18n('general.fieldModal.mobile_tip')} />;
        }
        if (isEmail) {
          return <OTCTip tip={getI18n('general.fieldModal.email_tip')} />;
        }
      }
    }

    return null;
  }, [isEmail, isMobile, isOptOptional, otpRequired]);

  const _dateOfBirthFields = React.useMemo(() => {
    const res = [];
    if (date.y) {
      res.push(DOB.Year);
    }
    if (date.m) {
      res.push(DOB.Month);
    }
    if (date.d) {
      res.push(DOB.Date);
    }
    return res;
  }, [date]);

  const onOkPress = () => {
    if (onOk) {
      const re: any = {
        field: category,
        required: required,
        isAddNew,
        index,
        dateOfBirthFields: _dateOfBirthFields,
      };
      if (isOptOptional) {
        re.otpRequired = otpRequired;
      }
      if (placeholderRequired) {
        re.placeholder = placeholder;
      }

      onOk(re);
    }
  };

  return (
    <Modal
      visible={visible}
      title={title || getI18n('general.fieldModal.customer_fields_title')}
      onCancel={onCancel}>
      <div className={css.container}>
        {!disableSelect && (
          <ItemWrapper
            title={getI18n('general.field')}
            belowComponentTitle={
              <OriCheckbox
                checked={required}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setRequired(checked);
                }}>
                {getI18n('general.fieldModal.required')}
              </OriCheckbox>
            }>
            <Select
              size='large'
              value={selectValue}
              labelInValue
              allowClear
              onChange={(e) => {
                const { value } = e || {};
                const ele = availableFields.find((i) => i.uuid === value);

                setCategory(ele || { value: null, label: null });
              }}>
              {options}
            </Select>
          </ItemWrapper>
        )}

        {!placeholderRequired && otc}
        {isDob && (
          <ItemWrapper
            errorText={getI18n('general.fieldModal.error_content')}
            title={getI18n('general.fieldModal.error_title')}
            error={dateErr}>
            <div className={css.checkboxTop}>
              <OriCheckbox
                checked={date.y}
                onChange={(e) => {
                  const t = e.target.checked;
                  setDate({ ...date, y: t });
                  setDateErr(false);
                }}>
                {getI18n('general.fieldModal.year')}
              </OriCheckbox>
            </div>
            <div className={css.checkboxTop}>
              <OriCheckbox
                onChange={(e) => {
                  const t = e.target.checked;
                  if (!t) {
                    setDate({ ...date, m: t, d: false });
                  } else {
                    setDate({ ...date, m: t });
                  }
                  setDateErr(false);
                }}
                checked={date.m}>
                {getI18n('general.fieldModal.month')}
              </OriCheckbox>
            </div>
            <div>
              <OriCheckbox
                onChange={(e) => {
                  const t = e.target.checked;
                  setDate({ ...date, d: t });
                  setDateErr(false);
                }}
                checked={date.d}
                disabled={!date.m}>
                {getI18n('general.fieldModal.date')}
              </OriCheckbox>
            </div>
          </ItemWrapper>
        )}
        {placeholderRequired && (
          <ItemWrapper
            title={`${getI18n('general.fieldModal.field_name')}*`}
            rightSubTitle={getI18n('general.fieldModal.placeholder')}>
            <Input
              value={placeholder}
              onChange={setPlaceholder}
              maxLength={100}
              size='large'
            />
          </ItemWrapper>
        )}
      </div>
      <ModalFooter
        okText={getI18n('general.tools_server.confirm')}
        cancelText={getI18n('general.commonHeader.discard_text')}
        onOk={onOkPress}
        onCancel={onCancel}
        hideOkButton={
          (!placeholder && placeholderRequired) ||
          !category ||
          !hasValue ||
          (isDob && !(date.y || date.m || date.d))
        }
      />
    </Modal>
  );
};
export default FieldModal;
